"use client";

import React from "react";
import { Leaf, Recycle, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  id: "compostable",
  text: "Compostable",
  icon: Recycle,
  positionClasses: "-top-5 left-1/2 -translate-x-1/2 md:-top-8"
}, {
  id: "plastic-free",
  text: "Plastic-Free",
  icon: ShieldCheck,
  positionClasses: "bottom-8 -left-6 md:bottom-16 md:-left-16"
}, {
  id: "sustainable",
  text: "Sustainably Sourced",
  icon: Leaf,
  positionClasses: "bottom-8 -right-6 md:bottom-16 md:-right-16"
}];
export default function EcoConsciousValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="eco-conscious-values" className="relative w-full overflow-hidden bg-gradient-to-b from-background via-primary/5 to-background py-24 md:py-32">
      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="text-center max-w-2xl mx-auto mb-16 md:mb-24">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6 tracking-tight">
            Our Eco-Conscious Values
          </h2>
          <p className="text-lg text-muted-foreground">
            At Cosmic EXIM LLC, we are committed to a greener future. Our dedicated line of plant-based products ensures that quality global trade doesn't come at the earth's expense.
          </p>
        </div>

        <div className="relative w-64 h-64 md:w-96 md:h-96 mt-8">
          <div className="absolute inset-0 rounded-full p-2 bg-background/50 backdrop-blur-sm shadow-2xl border border-primary/10">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1578090/img/biodegradable_plate_setup.png" alt="Biodegradable plant-based plate" className="w-full h-full object-cover rounded-full shadow-inner" />
          </div>

          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div key={benefit.id} data-index={i} className={`absolute z-20 transition-all duration-700 delay-${i * 200} ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"} ${benefit.positionClasses}`}>
                <Badge variant="outline" className="bg-background text-foreground border-border/50 shadow-lg px-4 py-2.5 md:px-6 md:py-3 rounded-full text-sm md:text-base font-medium flex items-center gap-2 hover:scale-105 transition-transform cursor-default">
                  <Icon className="w-4 h-4 md:w-5 md:h-5 text-primary" />
                  {benefit.text}
                </Badge>
              </div>;
        })}
        </div>
      </div>
    </section>;
}